export default {
  install (Vue) {
    Vue.directive('autoresize', {
      inserted (el) {
        el.style.overflow = 'hidden'
        el.style.resize = 'none'

        const resize = () => {
          el.style.height = 'auto'
          el.style.height = el.scrollHeight + 'px'
        }

        el.addEventListener('input', resize)

        // run once if textarea has pre-filled content
        resize()
      },
      unbind (el) {
        el.removeEventListener('input', () => {}) // cleanup
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/src/directives/auto-resize.directive.js